import React, { useState } from "react"

export const ContentSwitcherTab = ({ name, isDefault, children }) => {
  return (
    <div className="content-switcher__content" aria-live="polite">
      {children}
    </div>
  )
}

/**
 * <ContentSwitcher>
 *   <ContentSwitcherTab name="Monthly" isDefault="true">
 *    Some content (markdown or jsx)
 *   </ContentSwitcherTab>
 *
 *   <ContentSwitcherTab name="Annual">
 *    Some other content (markdown or jsx)
 *   </ContentSwitcherTab>
 * </ContentSwitcher>
 */
export const ContentSwitcher = ({ children }) => {
  const [activeTab, setActiveTab] = useState(
    children.find(child => child.props.isDefault)?.props?.name ??
      children[0].props.name,
  )

  return (
    <div className="content-switcher">
      <div>
        <div className="content-switcher__tabs">
          {children.map(child => (
            <button
              key={child.props.name}
              type="button"
              className="content-switcher__tab"
              data-active={activeTab === child.props.name ? "true" : "false"}
              onClick={() => setActiveTab(child.props.name)}
            >
              {child.props.name}
            </button>
          ))}
        </div>

        {children.filter(child => child.props.name === activeTab)}
      </div>
    </div>
  )
}
